<template>
    <div>
        <table-actions-menu>
            <edit-button
                :url="
                    route('tenant.clients.wbt-configs.show', {
                        client: data.client_id,
                        wbt_config: data.id
                    })
                "
            ></edit-button>

            <delete-button
                :url="
                    route('tenantapi.clients.wbt-configs.destroy', {
                        client: data.client_id,
                        wbt_config: data.id
                    })
                "
                :confirmTitle="this.trans('wbt_configs.note.delete_title')"
                :confirmText="this.trans('wbt_configs.note.delete_message')"
                :deleteId="data.id"
            ></delete-button>
        </table-actions-menu>
    </div>
</template>

<script>
import InlineSvg from '../../../util/inlineSvg.js';
import EditButton from '../../table_actions/table_actions_buttons/EditButton.vue';
import DeleteButton from '../../table_actions/table_actions_buttons/DeleteButton.vue';

export default {
    props: ['data', 'index'],

    components: {
        EditButton,
        DeleteButton,
        InlineSvg
    }
};
</script>
